import styled, { css } from 'styled-components';
import { EntityItemContainer } from 'components/Global/EntityItem/styled.js';

export const TopSixListContainer = styled.div`
  width: ${({ width }) => width};
  padding: 16px;
  display: inline-block;
  vertical-align: top;
  overflow: hidden;
  height: 100%;
  position: relative;
`;

export const EntityListItemContainer = styled.div`
  margin-right: 5%;
  display: block;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  font-size: 13px;
  width: 100%;
  padding: 12px 0;
  height: 50px;
  white-space: nowrap;

  &:last-child {
    border: none;
  }

  &:nth-child(3) {
    border: none;
  }

  &:nth-child(6) {
    border: none;
  }

  @media (max-width: 1300px) {
    padding: 6px 0;
  }

  ${EntityItemContainer} {
    display: inline-block;
    width: 80%;
  }
`;

export const EntityIndex = styled.div`
  width: 5px;
  margin-right: 20px;
  display: inline-block;
  color: white;
  line-height: 30px;
  vertical-align: top;
`;

export const TimeFilter = styled.div`
  display: inline-block;
  font-weight: bold;
  font-size: 10px;
  line-height: 14px;
  letter-spacing: 1.5px;
  text-transform: uppercase;
  margin-right: 24px;
  margin-bottom: 10px;
  color: #6994BB;

  &:hover {
    cursor: pointer;
  }

  ${({ selected, theme }) => selected && css`
    color: ${theme.colors.palette[6]};
    padding-bottom: 7px;
    border-bottom: 1px solid ${theme.colors.palette[6]};

    &:hover {
      cursor: default;
    }
  `}
`;

export const TickContainer = styled.div`
  position: absolute;
  bottom: 10px;
  left: 0;
  right: 0;
  width: auto;
  text-align: center;
`;

export const PageTick = styled.div`
  border-radius: 100%;
  color: white;
  background-color: white;
  height: 8px;
  width: 8px;
  display: inline-block;
  margin-right: 8px;
  opacity: 0.5;
  ${({ selected }) => selected && css`
    opacity: 1;
  `};

  &:hover {
    cursor: pointer;
  }
`;
